module.exports = __webpack_public_path__ + "img/9788952746894.7ce1d11a.jpg";